import { createToast } from "./Toast";

class ChooseToggles {
  constructor(elem, max) {
    this.selectCount = 0;
    this.selectCountMax = max;
    this.inputs = document.querySelectorAll(elem);
    this.init();
  }

  init() {
    this.checkInitialStates();
    this.inputs.forEach((input) => {
      input.addEventListener("change", (event) => {
        this.updateCounter(event.target);
      });
    });
  }

  checkInitialStates() {
    this.inputs.forEach((input) => {
      if (input.value == 1) {
        input.checked = true;
        input.value = "1";
        this.selectCount++;
      }
    });
  }

  updateCounter(changedinput) {
    if (changedinput.checked) {
      changedinput.value = "1";
      if (this.selectCount - 1 >= this.selectCountMax) {
        createToast({
          type: "error",
          message: `You have reached the selection limit of ${this.selectCountMax}`,
          duration: 2000,
          url: null,
        });
        changedinput.checked = false;
        changedinput.value = "0";
        return;
      }
      this.selectCount++;
    } else {
      changedinput.checked = false;
      changedinput.value = "0";
      if (this.selectCount < 0) {
        this.selectCount = 0;
      }
      this.selectCount--;
    }
  }
}

export { ChooseToggles };
